import React from "react";

const SkeletonTable = ({
  columnCount = 6,
  rowCount = 5,
  tableClassName = "",
  headers = [],
}) => {
  const SkeletonRow = ({ index }) => (
    <tr className="row" style={{ animationDelay: `${index * 0.1}s` }}>
      {Array.from({ length: columnCount }).map((_, i) => (
        <td key={i} className="cell">
          <div className="skeleton" />
        </td>
      ))}
    </tr>
  );

  return (
    <table className={`inventory-table ${tableClassName}`}>
      {headers.length > 0 && (
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
      )}
      <tbody className="skeleton-row">
        {Array.from({ length: rowCount }).map((_, i) => (
          <SkeletonRow key={`skeleton-${i}`} index={i} />
        ))}
      </tbody>
    </table>
  );
};

export default SkeletonTable;
